var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"slidoIframe",style:(_vm.$vuetify.breakpoint.smAndDown ? 'min-height: 100vh' : ''),attrs:{"src":_vm.setUser(_vm.link),"height":"100%","width":"100%","frameborder":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }